import { Injectable } from '@angular/core';
import { CartItemFrontend } from '../models/cart-item';

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'currentUser';
const CLIENT_KEY = 'currentCliente';
const CART_GUID_KEY= 'potteryCartGuidKey';
const CART_KEY = 'potteryCartKey';
const CART_ID_ADDRESS = 'cartIdAddress';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  constructor() { }

  signOut(): void {
    window.localStorage.clear();
  } 

  public saveToken(token: string): void {
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string | null {
    return localStorage.getItem('token');
  }

  public saveUser(user: any): void {
    window.localStorage.removeItem(USER_KEY);
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public saveCliente(cliente: any): void {
    window.localStorage.removeItem(CLIENT_KEY);
    window.localStorage.setItem(CLIENT_KEY, JSON.stringify(cliente));
  }

  public getUser(): any {
    const user = window.localStorage.getItem(USER_KEY);    
    if (user) {
      return JSON.parse(user);
    }

    return {};
  }

  public getClient(): any{
    const cliente = window.localStorage.getItem(CLIENT_KEY);
    if(cliente) {
      return JSON.parse(cliente);
    }
  }

  public deleteToken():any{
    window.localStorage.clear();
  }

  public saveCartGuid(guid:string){
    window.localStorage.removeItem(CART_GUID_KEY);
    window.localStorage.setItem(CART_GUID_KEY, guid);
  }

  public getCartGuid(){
    return window.localStorage.getItem(CART_GUID_KEY);  
  }

  public saveCart(carrello: CartItemFrontend[]){
    window.localStorage.removeItem(CART_KEY);
    window.localStorage.setItem(CART_KEY, JSON.stringify(carrello));
  }

  public getCart(){
    let carrello = window.localStorage.getItem(CART_KEY);
    if(carrello)
      return JSON.parse(carrello);
  }
  public saveIdAddress(id: number)
   {
    window.localStorage.removeItem(CART_ID_ADDRESS);
    window.localStorage.setItem(CART_ID_ADDRESS, id.toString());
   }

   public getIdAddress(id: number)
   {
    return window.localStorage.getItemItem(CART_ID_ADDRESS);
   }
}
 